<template>
  <v-row>
    <v-col v-for="tab in tabs" :key="tab.key" cols="12" sm="6" md="4">
      <v-card outlined hover class="report-stat-card" @click="$emit('open', tab.key)">
        <v-card-text>
          <div class="d-flex align-center mb-4">
            <v-icon color="primary" class="mr-3">{{ tab.icon }}</v-icon>
            <span class="subtitle-1 font-weight-medium">
              {{ $t(tab.label) }}
            </span>
          </div>

          <div class="d-flex align-baseline">
            <div class="report-stat-value">
              {{ statFor(tab.key, "total") }}
            </div>
            <div class="ml-2 text-caption grey--text">
              {{ $t("reports.statistics.total") }}
            </div>
          </div>

          <div class="mt-2 text-body-2 grey--text text--darken-1">
            {{ $t("reports.statistics.thisYear") }}:
            <b>{{ statFor(tab.key, "thisYear") }}</b>
          </div>
          <div class="text-body-2 grey--text text--darken-1">
            {{ $t("reports.statistics.thisMonth") }}:
            <b>{{ statFor(tab.key, "thisMonth") }}</b>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-4 py-3" @click.stop>
          <reportQuickActions :feature="tab.key" compact />
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import reportQuickActions from "../../components/_utils/reportQuickActions.vue";

export default {
  name: "reportsStatistics",
  components: { reportQuickActions },
  props: {
    tabs: { type: Array, default: () => [] },
  },
  data: () => ({ stats: {} }),
  async created() {
    for (const tab of this.tabs) {
      const data = await this.$store.dispatch(tab.statsAction);
      this.$set(this.stats, tab.key, data || {});
    }
  },
  methods: {
    statFor(key, field) {
      const entry = this.stats[key];
      if (!entry || entry[field] === undefined) return "–";
      return entry[field];
    },
  },
};
</script>

<style scoped>
.report-stat-card {
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.report-stat-card .v-card__text {
  flex-grow: 1;
}
.report-stat-value {
  font-size: 2rem;
  font-weight: 600;
  line-height: 1;
}
</style>
